import React, { useEffect, useState } from "react";
import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Stack from "@mui/material/Stack";
import AppNavbar from "../../../components/AppNavbar";
import Header from "../../../components/Header";
import SideMenu from "../../../components/SideMenu";
import AppTheme from "../../../shared-theme/AppTheme";
import {
  Button,
  Typography,
  TextField,
  InputAdornment,
  Pagination,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Box,
  Fade,
  Container
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Add, AssuredWorkloadOutlined, RemoveRedEyeOutlined, TrendingUp, AccountBalance } from "@mui/icons-material";
import StatusChip from "../../../components/StatusChip";
import { useNavigate } from "react-router-dom";
import { fetchProductosFinancieros } from "../../../utils/generalsFetch";
import { capitalizeFirstLetter, formatNumber } from "../../../utils/generalFunctions";
import AccessDeniedBox from "../../../components/AccessDeniedBox";
import EmptyState from "../../../components/EmptyState";

export default function FinancialProducts(props) {
  const navigate = useNavigate();
  const [accessDenied, setAccessDenied] = useState(false);

  const [productosFinancieros, setProductosFinancieros] = useState([]);

  useEffect(() => {
    fetchProductosFinancieros({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') })
    .then((data) => {
      setProductosFinancieros(data);
      setAccessDenied(false);
    })
    .catch(err => {
      setAccessDenied(true);
      console.log(err);
    })
    .catch(err => console.log(err));

  }, []);



  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: "flex" }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: "center",
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header parent={"Gestión Comercial"} child={"Productos Financieros"} />
            {/* Financial Products Content */}
            {!accessDenied ? 
            <Box px={10} py={4} maxWidth={"lg"} sx={{alignItems:"center", justifyContent:"center"}}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h3" fontWeight={700}>Productos Financieros</Typography>
                <Button variant="contained" color="primarybutton" startIcon={<Add/>} sx={{fontWeight:"bold"}} onClick={() => {navigate('/gestion_comercial/productos_financieros/crear')}}>
                  Crear Nuevo Producto
                </Button>
              </Box>

              {/* Show empty state if no products */}
              {productosFinancieros.length === 0 ? (
                <EmptyState 
                  icon={AccountBalance}
                  title="No hay productos financieros"
                  description="Comienza creando tu primer producto financiero para ofrecer préstamos, créditos y otros servicios a tus clientes."
                  features={[
                    {
                      icon: TrendingUp,
                      title: "Configuración Flexible",
                      description: "Personaliza tasas, plazos y condiciones"
                    },
                    {
                      icon: AssuredWorkloadOutlined,
                      title: "Gestión Automática",
                      description: "Cálculos automáticos de intereses y mora"
                    },
                    {
                      icon: AccountBalance,
                      title: "Reportes Detallados",
                      description: "Análisis completo de rendimiento"
                    }
                  ]}
                  buttonText="Crear Primer Producto Financiero"
                  onButtonClick={() => navigate('/gestion_comercial/productos_financieros/crear')}
                  helpText="¿Necesitas ayuda? Contacta a soporte técnico para guiarte en el proceso"
                />
              ) : (
                <>
                  <TextField
                    fullWidth
                    placeholder="Buscar por nombre..."
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    sx={{ mb: 3, bgcolor: "#f0f2f5", borderRadius: 2 }}
                  />

                  <Box display="flex" justifyContent="center" width="100%">
                    <Grid container spacing={3} sx={{ width: "70%" }}>
                      {productosFinancieros.map((product, index) => 
                      {
                        var generales = JSON.parse(product.generales);
                        var mora = JSON.parse(product.mora);
                        var interes = JSON.parse(product.interes);
                        var frecuenciaDePago = Array.isArray(generales.frecuenciaDePago) ? generales.frecuenciaDePago.join(", ") : generales.frecuenciaDePago;

                        
                        return (
                        <Grid item xs={12} key={index}>
                          <Card sx={{ display: "flex", borderRadius: 2, textAlign:"left"}}>
                            <CardContent sx={{ flex: 2 }}>
                              <Typography variant="h6" fontWeight={700}>{generales.nombre}</Typography>
                              
                              <Typography color="text.secondary">Tipo: {generales.tipo} | Tipo de interes: {interes.tipoInteres} | Frecuencia de Pago: {frecuenciaDePago} | Tipo de Mora: {mora.tipoMora} | Monto Minimo: {formatNumber(generales.montoMinimo,{locale: "es-DO",style:"currency", currency:"DOP"})} | Monto Maximo: {formatNumber(generales.montoMaximo,{locale: "es-DO",style:"currency", currency:"DOP"})}</Typography>
                              
                              <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                                <StatusChip status={capitalizeFirstLetter(product.estado)}/>
                                <Button variant="outlined" color="primarybutton" startIcon={<RemoveRedEyeOutlined/>} sx={{fontWeight:"bold",minWidth:130,height:35}} onClick={() => {navigate(`/gestion_comercial/productos_financieros/detalle/${product.idprodfinanciero}`)}}>
                                  Detalles
                                </Button>
                              </Box>
                            </CardContent>
                            {product.image && product.image!="" ? (
                            <CardMedia
                              component="div"
                              sx={{ width: 250, backgroundSize: "cover", backgroundImage: `url(${product.image})` }}
                            />
                            ):
                            <Box display="flex" justifyContent="center" alignItems="center" sx={{width:250, height:150}}>   
                              <AssuredWorkloadOutlined sx={{width:150, height:130, color:"primary.main"}}/>
                            </Box>
                            }
                          </Card>
                        </Grid>
                      );
                      })}
                    </Grid>
                  </Box>

                  <Box display="flex" justifyContent="center" mt={5}>
                    <Pagination count={10} color="primary" />
                  </Box>
                </>
              )}
            </Box>
            :
            <>
              <Box alignItems="left" mb={3}>
                <Typography variant="h3" fontWeight={700} textAlign={"left"}>Productos Financieros</Typography>
              </Box>
              <br></br>
              <br></br>
              <AccessDeniedBox
                title={'Acceso denegado'}
                message={'No tienes permisos para ver esta sección de Productos Financieros. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.'}
              />
            </>
            }
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}